export enum IdStatusProcesso {
    Cancelado = 99,
    Ativo = 1,
    Encerrado = 2,
    NaoProcessadoNaPlataforma = 3,
    EmPreAnalise = 4,
}
